export default "__VITE_ASSET__BbXA_pL$__"